import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/** Latest entry first by default, like the old logs list's `{ ActionDate: -1 }` sort. */
export const DEFAULT_ACTIVITY_LOGS_ORDER: OrderBy[] = [{ field: 'CreatedDate', direction: 'DESC' }];

export const buildGetActivityLogsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_ACTIVITY_LOGS_ORDER
) => `
  query {
    ActivityLogs: getActivityLogs(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        ModuleName
        EntityType
        EntityId
        Action
        PerformedBy
        PerformedByName
        Summary
        ChangesJson
      }
    }
  }
`;
